import CartCompletedView from './CartCompletedView';

export default CartCompletedView;
